/*
 * Copyright (c) 2021 CalAmp Corp. All Rights Reserved
*/
import produce from 'immer';
import {SET_SELECTED_DASHBOARD_TAB} from '@ion/applications/src/pages/dashboard/state';
import {PageState} from '@ion/applications/src/types/pages';
import {SET_GLOBAL_GROUP} from '@/store/actions/global-group-chooser';
import {PageInitializeAction} from '@/types/redux';

export const INITIALIZE_DASHBOARD = 'INITIALIZE_DASHBOARD';

/**
 * @initialize
 */
export const initializeDashboard = (): PageInitializeAction => {
  return {type: INITIALIZE_DASHBOARD};
};

// defines the dashboard tabs available for CTC (ADM)
export enum DashboardTab {
  OVERVIEW = 0,
  MONTHLY_REPORT = 1,
  YEARLY_REPORT = 2,
  CRASHBOXX = 3
};

// defines the type definitions for dashboard actions ...
export interface DashboardAction {
  selectedTab: DashboardTab;
};

export interface DashboardState extends PageState {
  isInitialized: boolean;
  selectedTab: DashboardTab;
};

const defaultDashboardTab: DashboardTab = DashboardTab.OVERVIEW;

// defines the initial state for the reducer ...
export const initialState: DashboardState = {
  isInitialized : false,
  selectedTab   : defaultDashboardTab
};

// defines this reducers reducer functions ...
const reducers = {
  [INITIALIZE_DASHBOARD] : draft => {
    draft.isInitialized = true;
  },
  [SET_SELECTED_DASHBOARD_TAB] : (
    draft: DashboardState, {selectedTab}: DashboardAction) => {
    draft.selectedTab = selectedTab;
  },
  [SET_GLOBAL_GROUP] : (draft: DashboardState) => {
    draft.selectedTab = defaultDashboardTab;
  }
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: DashboardState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
